import { Resource } from '@redge-media/fo-js-sdk';
import Vod from './vod';

const Vods = Resource.extend({
  endpoint: '/products/vods',

  constructor: function Vods() {
    Resource.call(this);

    this.recordClass = Vod;
    this.meta = {};
  },

  deserialize(response, opts = {}) {
    const data = Resource.prototype.deserialize.call(this, response, opts);
    this.meta = data.meta || {};
    return data.items || data;
  },

  getPath(method, props = {}) {
    let path = Resource.prototype.getPath.call(this, method, props);
    if (method === 'fetchAll') {
      path += '/list';
    }

    return path;
  },
});

export default Vods;
